import type { FaireProductEntity } from "../../entity_types/product";

export const p_jzs3432huv: FaireProductEntity = {
  token: "p_jzs3432huv",
  type: "product",
  name: "Arkansas Razorbacks Necklace  Razorback GameDay Perfect Gift",
  brandToken: "b_af92w55rjq",
  brandName: "Steele Sloan Designs",
  imageUrl:
    "https://cdn.faire.com/fastly/d2183850af2f913465c2e2708c9546a5267d2a1030c3cfbce0fef07aff950799.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/9e50834b0e7223164ca186ebf4d39ed56ce2fa8eb256609e4ecc39549c221a8d.jpeg",
    "https://cdn.faire.com/fastly/3559a4008dc2a9772864e8657dad4588874ee43d531b83c575de4c8d5d72e404.jpeg",
    "https://cdn.faire.com/fastly/6aa1b20483efa13439f5e172d5dff797b3bbfceea55d2c2da4b94accba63f8e9.jpeg",
    "https://cdn.faire.com/fastly/caacaea2557592213c1e914c8d8a03bc4c81ff78124303872426c726e13a41bd.jpeg",
  ],
  priceDollars: 30.49,
  description:
    'NEW! University of Arkansas Razorbacks Necklace - Razorback GameDay Perfect Gift for Razorback Fans\n\nPERFECT for all Razorback Fans!  Gold Hypoallergenic and Tarnish Resistant Stainless Steel "Razorbacks" Necklace is sure to be a favorite for all Razorbacks!  Necklace measures 15 1/2 inches with 2 inch extension - BEST GameDay Accessory and a MUST HAVE!  Officially Licensed.  (more pictures soon!)\n***Earrings and necklaces must stay on my branded cards and at msrp pricing***#gohogs #razorbacks',
  tags: [],
  msrpDollars: 60.97,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:49:48.570Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
